import React, { useState } from 'react';
import { TopNav } from '../components/TopNav';
import { useAuth } from '@/hooks/useAuth';
import { updateMe, uploadAvatar } from '@/services/users';
import { useToast } from '@/components/ToastProvider';

interface PageProps { theme: string; toggleTheme: () => void }

const SettingsPage: React.FC<PageProps> = ({ theme, toggleTheme }) => {
  const { user, refresh } = useAuth();
  const toast = useToast();
  const [name, setName] = useState<string>(user?.name || '');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  const onSave = async () => {
    try {
      setBusy(true); setMsg(null);
      await updateMe({ name: name.trim() || undefined });
      await refresh();
      toast.success('Dados atualizados');
      setMsg(null);
    } catch (e:any) { toast.error('Falha ao salvar', e?.message); setMsg(e?.message || 'Falha ao salvar'); }
    finally { setBusy(false); }
  };

  const onPickAvatar = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0]; if (!f) return;
    try { setBusy(true); setMsg(null); await uploadAvatar(f); await refresh(); toast.success('Foto atualizada'); }
    catch (e:any) { toast.error('Falha no upload', e?.message); setMsg(e?.message || 'Falha no upload'); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-body">
      <TopNav theme={theme} toggleTheme={toggleTheme} />
      <main className="max-w-3xl mx-auto p-3 md:p-4 space-y-4">
        <header>
          <h1 className="text-xl font-extrabold text-primary">Configurações</h1>
          <p className="text-sm text-muted">Preferências da conta e aparência.</p>
        </header>
        <section className="bg-surface rounded-lg border border-default p-4">
          <h2 className="font-bold text-primary mb-3">Perfil</h2>
          <div className="flex items-center gap-4 mb-3">
            <img src={user?.avatarUrl || 'https://placehold.co/64x64/1DB954/FFFFFF?text=I'} alt="Avatar" className="w-16 h-16 rounded-full border border-default" />
            <div>
              <label className="text-xs text-muted block mb-1">Alterar foto</label>
              <input type="file" accept="image/*" onChange={onPickAvatar} />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <label className="block">
              <span className="text-xs text-muted">Nome</span>
              <input value={name} onChange={e=>setName(e.target.value)} className="mt-1 w-full px-3 py-2 rounded-md border border-default bg-transparent" />
            </label>
            <label className="block">
              <span className="text-xs text-muted">Email</span>
              <input value={user?.email || ''} disabled className="mt-1 w-full px-3 py-2 rounded-md border border-default bg-zinc-100 dark:bg-zinc-800/50" />
            </label>
          </div>
          <div className="mt-3 flex items-center gap-2">
            <button onClick={onSave} disabled={busy} className="px-3 py-2 rounded-md bg-[#1DB954] text-black font-semibold disabled:opacity-50">Salvar</button>
            {msg && <span className="text-xs text-muted">{msg}</span>}
          </div>
        </section>
        <section className="bg-surface rounded-lg border border-default p-4">
          <h2 className="font-bold text-primary mb-2">Aparência</h2>
          <button onClick={toggleTheme} className="px-3 py-2 rounded-md bg-[#1DB954] text-black font-semibold">Alternar tema</button>
        </section>
      </main>
    </div>
  );
};

export default SettingsPage;
